import React, { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { Alert, Button } from '@wmgtech/legato'

import { ScrollToTopButton } from 'components/index'
import { usePreviewStepProject } from 'modules/Globalize/serviceHooks'
import { useZoneMenu } from 'modulesCommon/serviceHooks'
import { GlobalProjectTop } from 'modules/GlobalProject/containers/GlobalProjectTop'

import styles from './PreviewLayout.module.scss'

export const GlobalPreviewLayout: FC = () => {
  const { onExit } = usePreviewStepProject()
  useZoneMenu()
  return (
    <>
      <Alert
        className={styles.containerAlert}
        title={
          <>
            <span>This is just a preview of your project. To exit the preview, click the exit button on the right or use the back button on your browser. </span>
            <Button
              size="sm"
              label="Exit"
              containerStyle={'solid'}
              colorType="warning"
              className={styles.containerAlertBtn}
              onClick={onExit}
            />
          </>
        }
        colorType="warning"
        dissmisable={false}
        icon="warning"
      />
      <div className={styles.container}>
        <GlobalProjectTop />
        <Outlet />
        <ScrollToTopButton />
      </div>
    </>
  )
}
